import React from "react";
import { Building, hasCalendarSoftware, softwareTypeLabel, hasServiceType, serviceTypeLabel } from "../../../interfaces/Building";
import { IonButton, IonChip, IonCol, IonIcon, IonRow } from "@ionic/react";
import MainThumbnailImage from "../../MainThumbnailImage";
import {
    REACT_APP_AWS_BUCKET_NAME,
    REACT_APP_AWS_REGION,
  } from "../../../actions/settings";
import CheckRole from "../../extras/CheckRole";
import { useAppSelector } from "../../../Hooks";
import { selectUser } from "../../../reducers/UserReducer";
import { copy, copyOutline, createOutline } from "ionicons/icons";
import { isStaff } from "../../extras/Functions";

interface IProps {
    building:Building
};

const BuildingInfoCard:React.FC<IProps> = ({building}) => {
    const user = useAppSelector(selectUser);
    const newUI = localStorage.getItem("newUI")?.toLowerCase() === 'true';

    const copyUUID = () => {
        navigator.clipboard.writeText(building.uuid);
        const popup = document.getElementById("copied");
        popup?.classList.toggle("show");
        setTimeout(() => {
          const popup = document.getElementById("copied");
          popup?.classList.toggle("show");
        }, 3000);
      };
    let customer = null

    if (typeof building.cust_uuid === 'object' && building.cust_uuid !== null){
        customer = building.cust_uuid
    }

    return <div>
        <IonRow>
            <IonCol size="12" sizeMd="6">
                <div style={{ display: "flex", justifyContent: "center" }}>
                    <MainThumbnailImage
                        style={{ maxWidth: "250px" }}
                        src={`https://${REACT_APP_AWS_BUCKET_NAME}.s3.${REACT_APP_AWS_REGION}.amazonaws.com/thumbnails/pics/${building.uuid}-building-img`}
                    />
                </div>
                <div style={{marginTop:'0.5rem', display: "flex", justifyContent: "center"}} >
                    <IonChip title="Software Type" color={hasCalendarSoftware(building.software_type) ? "success" : 'danger'}>{softwareTypeLabel(building.software_type) || "No Calendar Software"}</IonChip>
                    <IonChip title="Service Type" color={hasServiceType(building.service_type) ? "success" : 'danger'}>{serviceTypeLabel(building.service_type) || "No Service Type"}</IonChip>                    
                </div>
            </IonCol>
            <IonCol>
                <div style={{display:'flex'}}>
                    <div>
                        <h1 style={{
                            paddingBottom:'0',
                            marginBottom:'0',
                            fontSize:'2em'
                        }}>{building.building_name}</h1>
                        {customer ? <div style={{
                            paddingTop:'0',
                            marginTop:'0',
                            marginLeft:'0.7rem'
                        }} ><a
                        href={`/?id=${customer.uuid}&sec=customers`}
                        style={newUI ? {color:'black'}:{color:'white'}}
                      >
                        ({customer.cust_name})
                      </a></div> : null}
                    </div>
                    <IonButton
                        hidden={!CheckRole(user, ["Admin", "Supervisor"])}
                        id="edit-building"
                        fill="clear"
                        color={newUI?'dark':'light'}
                        slot="icon-only"
                        href={`/building/${building.uuid}/edit`}
                        // className="testing"
                    >
                        <IonIcon slot="icon-only" src={createOutline}></IonIcon>
                    </IonButton>
                </div>
                {isStaff(user) ? (
              <div>
                <span className="popup">
                  <span className="popuptext" id="copied">
                    Copied
                  </span>
                  <IonButton
                    className="clipboardButton"
                    color={newUI?'dark':'light'}
                    slot="icon-only"
                    fill="clear"
                    onClick={copyUUID}
                  >
                    {" "}
                    <IonIcon md={copy} ios={copyOutline} />
                    COPY ID
                  </IonButton>{" "}
                </span>{" "}
              </div>
            ) : (
              null
            )}
            <p className={newUI?'text-dark-blue':''}>
                {building.building_address}{" "}
              {building.building_address_2 ? building.building_address_2 : ""}
              {building.building_city}, {building.building_state}{" "}
              {building.building_zipcode}
            </p>
            <p className={newUI?'text-dark-blue':''}>
                Primary Function: {building.building_type?.name}
            </p>
            <p className={newUI?'text-dark-blue':''}>
              Square Footage: {building.building_sq_ft?.toLocaleString("en")} ft<sup>2</sup>
            </p>
            </IonCol>
        </IonRow>
    </div>
};

export default BuildingInfoCard;